import { useComparer } from '@/hooks/useComparer';
import { useExpandable } from '@/hooks/useExpandable';
import { ComparerCommon, ComparerResults } from '@/types/comparer';
import { Typography } from '@mui/material';
import { Fragment, type FC } from 'react';
import SectionHeader from '../comparerShared/SectionHeader';
import { commonCategories, getChangedItems, getVisibleItems } from '../comparerUtils/comparerUtils';
import CommonChanges from './CommonChanges';

type CommonCategoriesChangesProps = {
  results: ComparerResults;
};

type CommonCategorySectionProps = {
  label: string;
  categories: ComparerCommon[];
};

const CommonCategorySection: FC<CommonCategorySectionProps> = ({ label, categories }) => {
  const { showUnchanged } = useComparer();

  const changedCategories = getChangedItems(categories);
  const visibleCategories = getVisibleItems(categories, showUnchanged);

  const [open, setOpen] = useExpandable(changedCategories.length > 0);

  if (!visibleCategories.length) return <Fragment />;
  return (
    <>
      <SectionHeader open={open} setOpen={setOpen} expandable={visibleCategories.length > 0}>
        <Typography variant='subtitle2' fontWeight={700}>
          {label}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          {changedCategories.length} changed
        </Typography>
      </SectionHeader>
      {open && <CommonChanges categories={categories} />}
    </>
  );
};

const CommonCategoriesChanges: FC<CommonCategoriesChangesProps> = ({ results }) => {
  return commonCategories.map(({ key, label }) => (
    <CommonCategorySection key={key} label={label} categories={results[key]} />
  ));
};

export default CommonCategoriesChanges;
